/* eslint-disable eslint-comments/no-restricted-disable */
/* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { dashboardPanelEntryPoint } from '@jira/itam__ham-dashboard/src/dashboardPanelEntryPoint.entrypoint.tsx';
import { overviewEntryPoint } from '@jira/itam__ham-overview/src/overviewEntryPoint.entrypoint.tsx';
import { assetsEntryPoint } from '@jira/itam__ham-assets/src/assetsEntryPoint.entrypoint.tsx';
import { assetModelsEntryPoint } from '@jira/itam__ham-asset-models/src/assetModelsEntryPoint.entrypoint.tsx';
import { stockroomsEntryPoint } from '@jira/itam__ham-stockrooms/src/stockroomsEntryPoint.entrypoint.tsx';
import { workItemsEntryPoint } from '@jira/itam__ham-work-items/src/workEntryPoint.entrypoint.tsx';
import type { ItamPermissionsBoundaryTenantContextQuery } from '@jira/itam__tenant-context/src/__generated__/ItamPermissionsBoundaryTenantContextQuery.graphql.ts';
import itamPermissionsParams from '@jira/itam__tenant-context/src/__generated__/ItamPermissionsBoundaryTenantContextQuery$parameters.ts';
import { getStaticPermissionChecks } from '@jira/itam__tenant-context/src/getStaticPermissionChecks.tsx';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { JSResourceForInteraction } from '@atlassian/react-async';

type ItamEntryPointComponent = EntryPointComponent<
	{ itamPermissions: ItamPermissionsBoundaryTenantContextQuery },
	{},
	{},
	{}
>;

export const itamEntryPoint: EntryPoint<ItamEntryPointComponent, EntryPointRouteParams> =
	createEntryPoint({
		root: JSResourceForInteraction<ItamEntryPointComponent>(
			/* webpackChunkName: "async-itam-entrypoint", jiraSpaEntry: "async-itam-entrypoint" */ './ItamPage.tsx',
		),
		getPreloadProps: ({
			context: { query },
			tenantContext: { cloudId },
		}: EntryPointRouteParams) => {
			const { tab } = query;
			const queries = {
				itamPermissions: {
					parameters: itamPermissionsParams,
					variables: { cloudId, staticChecks: getStaticPermissionChecks(cloudId) },
					options: { fetchPolicy: 'store-or-network' as const },
				},
			};

			if (tab === 'hardware') {
				return { entryPoints: { assetsEntryPoint: { entryPoint: assetsEntryPoint } }, queries };
			}
			if (tab === 'models') {
				return {
					entryPoints: { assetModelsEntryPoint: { entryPoint: assetModelsEntryPoint } },
					queries,
				};
			}
			if (tab === 'stockrooms') {
				return {
					entryPoints: { stockroomsEntryPoint: { entryPoint: stockroomsEntryPoint } },
					queries,
				};
			}
			if (tab === 'work') {
				return { entryPoints: { workEntryPoint: { entryPoint: workItemsEntryPoint } }, queries };
			}
			if (tab === 'dashboard') {
				return {
					entryPoints: { dashboardPanelEntryPoint: { entryPoint: dashboardPanelEntryPoint } },
					queries,
				};
			}
			// Overview tab (and default): preload overview entry point
			return { entryPoints: { overviewEntryPoint: { entryPoint: overviewEntryPoint } }, queries };
		},
	});
